import React from 'react';
import { Text } from './UploadWarningStyles';

export const UploadWarning: React.FC = () => {
  return (
    <Text>
      <u>Do not</u> turn off or put the computer to sleep until the status of pending video uploads reads “Uploaded”.
    </Text>
  );
};
